import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=61912dd8&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"
import style0 from "./Operate.vue?vue&type=style&index=0&id=61912dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61912dd8",
  null
  
)

export default component.exports